<template>
    <div class="wrapper" v-if="showComponent">
        <div class="label">{{translations.countdownHeader}}</div>
        <div class="countdown">
            <div class="countdown-component">
                <div class="value">{{days}}</div>
                <div class="label">{{translations.days}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{hours}}</div>
                <div class="label">{{translations.hours}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{minutes}}</div>
                <div class="label">{{translations.minutes}}</div>
            </div>
            <div class="countdown-component">
                <div class="value">{{seconds}}</div>
                <div class="label">{{translations.seconds}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { StringService } from '@nuskin/ns-util'

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

export default {
  name: 'EventCountdown',
  props: {
    qualifications: Object
  },
  data() {
    return {
      waitTime: 0,
      translations: null
    }
  },

  computed: {
    showComponent() {
      return !!this.translations && this.waitTime > 0
    },
    days() {
      return Math.floor(this.waitTime / DAY)
    },
    hours() {
      return Math.floor(this.waitTime % DAY / HOUR)
    },
    minutes() {
      return Math.floor(this.waitTime % HOUR / MINUTE)
    },
    seconds() {
      return Math.floor(this.waitTime % MINUTE / SECOND)
    }
  },
  watch: {
    qualifications() {
      const newWaitTime = Object.values(this.qualifications || {})
        .map(qualification => qualification.purchaseStartDate)
        .sort()
        .reverse()[0] - Date.now()

      this.setWaitTime(newWaitTime)
    }
  },

  mounted() {
    this.setContent()
    this.startCount()
  },

  methods: {
    setWaitTime(waitTime) {
      this.waitTime = Math.max(waitTime, 0)
    },
    async startCount() {
      const sleepOneSecond = async () => await new Promise(resolve => setTimeout(() => resolve(true), SECOND))

      while (this.waitTime > 0) {
        this.setWaitTime(this.waitTime - SECOND)
        await sleepOneSecond()
      }
    },
    async setContent() {
      this.translations = await StringService.getApplicationStrings('preview')
    }
  }
}

</script>

<style scoped lang="scss">
    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        border: 1px solid #63666a;
        max-width: 325px;
        margin: 15px auto 0;
        padding: 5px;

        .label {
            font-size: 14px;
            text-transform: uppercase;
        }

        .countdown {
            display: flex;
            justify-content: center;

            .countdown-component {
                display: flex;
                flex-direction: column;
                width: 75px;

                .value {
                    font-weight: bold;
                    font-size: 22px;
                }

                .label {
                    font-size: 12px;
                }
            }
        }
    }

</style>
